import { types } from "../Types/agent";

export function getAgent() {
  return { type: types.GET_AGENT };
}

export function updateAgent(payload: any) {
  return { type: types.UPDATE_AGENT, payload };
}

export function addAgentExample(payload: any) {
  return { type: types.ADD_AGENT_EXAMPLE, payload };
}

export function testAgent(payload: any) {
  return { type: types.TEST_AGENT, payload };
}

export function clearAgentTest() {
  return { type: types.CLEAR_AGENT_TEST };
}

export function getInboxMessages() {
  return { type: types.GET_INBOX_MESSAGES };
}

export function getDrafts(status?: string) {
  return { type: types.GET_DRAFTS, payload: status };
}

export function getDraftStats() {
  return { type: types.GET_DRAFT_STATS };
}

export function generateDraft(inboundMessageId: string, force?: boolean) {
  return { type: types.GENERATE_DRAFT, payload: { inboundMessageId, force } };
}

export function updateDraftBody(id: string, body: string) {
  return { type: types.UPDATE_DRAFT_BODY, payload: { id, body } };
}

export function decideDraft(id: string, action: string, body?: string) {
  return { type: types.DECIDE_DRAFT, payload: { id, action, body } };
}

export function sendDraft(id: string) {
  return { type: types.SEND_DRAFT, payload: { id } };
}

export function startWatch() {
  return { type: types.START_WATCH };
}

export function stopWatch() {
  return { type: types.STOP_WATCH };
}

export function getAvatars() {
  return { type: types.GET_AVATARS };
}

export function createAvatar(payload: any) {
  return { type: types.CREATE_AVATAR, payload };
}

export function syncAvatar(id: string) {
  return { type: types.SYNC_AVATAR, payload: { id } };
}

export function requestAvatarConsent(id: string) {
  return { type: types.REQUEST_AVATAR_CONSENT, payload: { id } };
}

export function setDefaultAvatar(id: string) {
  return { type: types.SET_DEFAULT_AVATAR, payload: { id } };
}

export function deleteAvatar(id: string) {
  return { type: types.DELETE_AVATAR, payload: { id } };
}

export function createDraftVideo(id: string, payload?: any) {
  return { type: types.CREATE_DRAFT_VIDEO, payload: { id, ...(payload || {}) } };
}
